<div appFocusNearest *isLoading="!IsFormInitialized">
  <app-dynamic-sachverhalte-form
    [header]="header"
    [sachverhaltId]="sachverhaltId"
    [erfassungSachverhaltId]="erfassungSachverhaltId"
    [fields]="fields"
    [values]="values"
    [emptyFields]="emptyFields"
    [serverValidationErrors]="serverValidationErrors$ | async"
  >
  </app-dynamic-sachverhalte-form>

  <div class="uba-button-group">
    <button class="btn btn-default" (click)="close()">
      {{ 'action.cancel' | translate }}
    </button>
    <button class="btn btn-primary" [disabled]="IfValuesNotExists" (click)="saveSachverhalt()">
      <i class="fas fa-sm fa-save" aria-hidden="true"></i> {{ 'action.save' | translate }}
    </button>
  </div>
</div>
